import { type ComponentProps } from "react";

const PowerIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg 
    width="25" 
    height="26" 
    viewBox="0 0 25 26" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
<path d="M4.07736 5.16511C3.81893 4.90957 3.40094 4.9109 3.15948 5.18255C1.66789 6.86054 0.652559 8.91291 0.226085 11.1258C-0.241987 13.5546 0.0203048 16.0677 0.979792 18.3474C1.93928 20.627 3.55287 22.5708 5.61651 23.9329C7.68015 25.295 10.1012 26.0143 12.5734 25.9998C15.0456 25.9853 17.458 25.2376 19.5055 23.8513C21.553 22.4651 23.1437 20.5025 24.0764 18.2117C25.009 15.921 25.2418 13.4049 24.7453 10.9818C24.2929 8.77406 23.2535 6.73376 21.7424 5.0734C21.4977 4.80461 21.0797 4.80818 20.8243 5.06674L19.5466 6.36027C19.2911 6.61883 19.2955 7.03414 19.5354 7.3072C20.6083 8.52849 21.3477 10.0113 21.6756 11.6115C22.0477 13.4272 21.8732 15.3125 21.1744 17.029C20.4755 18.7455 19.2836 20.2161 17.7494 21.2548C16.2151 22.2936 14.4075 22.8538 12.555 22.8647C10.7025 22.8756 8.88841 22.3366 7.34209 21.316C5.79577 20.2953 4.58668 18.8388 3.86772 17.1306C3.14876 15.4225 2.95222 13.5393 3.30295 11.7194C3.61206 10.1155 4.33403 8.62408 5.39248 7.39027C5.62912 7.11441 5.62865 6.69907 5.37023 6.44353L4.07736 5.16511Z" fill="currentColor"/>
<path d="M10.959 0.987342C10.959 0.442048 11.4009 0 11.9459 0H13.2617C13.8067 0 14.2485 0.442048 14.2485 0.987343V12.1772C14.2485 12.7225 13.8067 13.1646 13.2617 13.1646H11.9459C11.4009 13.1646 10.959 12.7225 10.959 12.1772V0.987342Z" fill="currentColor"/>
</svg>

  );
};

export default PowerIcon;